export default __webpack_public_path__ + "static/media/areaChart.31d8b0c0.svg";